export const PAGES = {
  login_page: "login_page",
  dashboard: "dashboard",
  project_listing: "project_listing_fms",
  unit_listing: "unit_listing_fms",
  payment_listing: "payment_listing_fms",
  client_listing: "client_listing_fms",
  agreement_listing: "agreement_listing",
  bill_listing: "bill_listing",
  booking_listing: "booking_listing",
  booking_detail: "booking_detail",
  recovery_listing: "recovery_listing",
  transfer_listing: "transfer_listing",
  payment_listing_v2: "payment_listing",
  tasks_listing: "tasks_listing",
  client_listing_v2: "client_listing",
  client_detail: "client_detail",
  project_listing_v2: "project_listing",
  unit_listing_v2: "unit_listing",
};

export const EVENT_NAMES = {
  click: "click",
  filter: "filter",
  page_view: "page_view",
  login: "login",
  project_actions: "project_actions",
  unit_actions: "unit_actions",
  client_actions: "client_actions",
  agreement_actions: "agreement_actions",
  bill_actions: "bill_actions",
  payment_actions: "payment_actions",
};

export const CONTENT_TYPES = {
  login_page: "login_page",
  login_with_google: "login_with_google",
  login_with_credentials: "login_with_credentials",
  email_password: "email_password",
  // dashboard: "dashboard_fms",
  dashboard_v2: "dashboard",
  project_listing: "project_listing_fms",
  add_project: "add_project_fms",
  edit_project: "edit_project_fms",
  project_filter: "project_filter_fms",
  project_filter_v2: "project_filter",
  city_filter: "city_filter_fms",
  unit_listing: "unit_listing_fms",
  unit_detail: "unit_detail_fms",
  unit_edit: "unit_edit_fms",
  add_unit: "add_unit_fms",
  client_listing: "client_listing_fms",
  // client_detail: "client_detail_fms",
  client_edit: "client_edit_fms",
  add_client: "add_client_fms",
  agreement_listing: "agreement_listing",
  agreement_detail: "agreement_detail",
  agreement_edit: "agreement_edit",
  add_agreement: "add_agreement",
  bill_listing: "bill_listing",
  add_bill: "add_bill",
  bill_detail: "bill_detail",
  bill_edit: "bill_edit",
  bill_update: "bill_update",
  payment_listing: "payment_listing_fms",
  // payment_detail: "payment_detail_fms",
  payment_update: "payment_update_fms",
  add_payment: "add_payment_fms",
  role_listing: "role_listing_fms",
  booking_listing: "booking_listing",
  create_new_booking: "create_new_booking",
  import_booking: "import_booking",
  booking_edit: "booking_edit",
  booking_whatsapp: "booking_whatsapp",
  booking_change_disposition: "booking_change_disposition",
  booking_restore: "booking_restore",
  booking_share_account_statement: "booking_share_account_statement",
  booking_change_assignee: "booking_change_assignee",
  booking_history: "booking_history",
  booking_detail: "booking_detail",
  booking_edit_installments: "booking_edit_installments",
  booking_adjust_cost: "booking_adjust_cost",
  booking_add_payment: "booking_add_payment",
  booking_add_task: "booking_add_task",
  booking_download_account_statement: "booking_download_account_statement",
  recovery_listing: "recovery_listing",
  recovery_detail: "recovery_detail",
  transfer_listing: "transfer_listing",
  add_transfer: "add_transfer",
  refund_listing: "refund_listing",
  payment_listing_v2: "payment_listing",
  add_new_payment: "add_new_payment",
  payment_update_v2: "payment_update",
  tasks_listing: "tasks_listing",
  tasks_add_task: "tasks_add_task",
  client_listing_v2: "client_listing",
  client_detail_v2: "client_detail",
  client_edit_v2: "client_edit",
  approval_listing: "approval_listing",
  user_listing: "user_listing",
  role_listing_v2: "role_listing",
  team_listing: "team_listing",
  tenant_settings: "tenant_settings",
  project_listing_v2: "project_listing",
  add_new_project: "add_new_project",
  project_detail: "project_detail",
  city_filter_v2: "city_filter",
  project_edit_v2: "project_edit",
  project_status_v2: "project_status",
  project_app_v2: "project_app",
  project_history_v2: "project_history",
  unit_listing_v2: "unit_listing",
  project_filter_unit: "project_filter",
  unit_filter_unit: "unit_filter",
  property_category_filter: "property_category_filter",
  unit_type_filter: "unit_type_filter",
  client_filter: "client_filter",
  unit_detail_v2: "unit_detail",
  add_new_unit: "add_new_unit",
  import_units: "import_units",
  unit_edit_v2: "unit_edit",
  unit_history_v2: "unit_history",
};

export const ACTION_TYPES = {
  login_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.login_page,
  },
  login_with_google_click: {
    interacted_from: PAGES.login_page,
    event_name: EVENT_NAMES.login,
    content_type: CONTENT_TYPES.login_with_google,
  },
  login_with_credentials_click: {
    interacted_from: PAGES.login_page,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.login_with_credentials,
  },
  login_with_email_password: {
    interacted_from: PAGES.login_page,
    event_name: EVENT_NAMES.login,
    content_type: CONTENT_TYPES.email_password,
  },
  dashboard_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.dashboard_v2,
  },
  project_filter_click: {
    interacted_from: PAGES.dashboard,
    event_name: EVENT_NAMES.filter,
    content_type: CONTENT_TYPES.project_filter_v2,
  },
  landing_on_projects_module_fms: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.project_listing,
  },
  add_new_project_click: {
    interacted_from: PAGES.project_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.add_project,
  },
  project_filter: {
    interacted_from: PAGES.project_listing,
    event_name: EVENT_NAMES.filter,
    content_type: CONTENT_TYPES.project_filter,
  },
  city_filter: {
    interacted_from: PAGES.project_listing,
    event_name: EVENT_NAMES.filter,
    content_type: CONTENT_TYPES.city_filter,
  },
  edit_project_click: {
    interacted_from: PAGES.project_listing,
    event_name: EVENT_NAMES.project_actions,
    content_type: CONTENT_TYPES.edit_project,
  },
  landing_on_units_module_fms: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.unit_listing,
  },
  landing_on_units_detail_page_fms: {
    interacted_from: PAGES.unit_listing,
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.unit_detail,
  },
  add_new_unit_click: {
    interacted_from: PAGES.unit_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.add_unit,
  },
  edit_unit_click: {
    interacted_from: PAGES.unit_listing,
    event_name: EVENT_NAMES.unit_actions,
    content_type: CONTENT_TYPES.unit_edit,
  },
  landing_on_clients_module_fms: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.client_listing,
  },
  add_new_client_click: {
    interacted_from: PAGES.client_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.add_client,
  },
  edit_client_click: {
    interacted_from: PAGES.client_listing,
    event_name: EVENT_NAMES.client_actions,
    content_type: CONTENT_TYPES.client_edit,
  },
  landing_on_agreements_module: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.agreement_listing,
  },
  landing_on_agreement_detail_page: {
    interacted_from: PAGES.agreement_listing,
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.agreement_detail,
  },
  agreement_name_click: {
    interacted_from: PAGES.agreement_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.agreement_detail,
  },
  add_new_agreement_click: {
    interacted_from: PAGES.agreement_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.add_agreement,
  },
  edit_agreement_click: {
    interacted_from: PAGES.agreement_listing,
    event_name: EVENT_NAMES.agreement_actions,
    content_type: CONTENT_TYPES.agreement_edit,
  },
  landing_on_bills_module: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.bill_listing,
  },
  bill_name_click: {
    interacted_from: PAGES.bill_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.bill_detail,
  },
  add_new_bill_click: {
    interacted_from: PAGES.bill_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.add_bill,
  },
  // edit_bill_click: {
  //   interacted_from: PAGES.bill_listing,
  //   event_name: EVENT_NAMES.bill_actions,
  //   content_type: CONTENT_TYPES.bill_edit,
  // },
  update_bill_click: {
    interacted_from: PAGES.bill_listing,
    event_name: EVENT_NAMES.bill_actions,
    content_type: CONTENT_TYPES.bill_update,
  },
  landing_on_payments_module_fms: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.payment_listing,
  },
  add_new_payment_click: {
    interacted_from: PAGES.payment_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.add_payment,
  },
  update_payment_click: {
    interacted_from: PAGES.payment_listing,
    event_name: EVENT_NAMES.payment_actions,
    content_type: CONTENT_TYPES.payment_update,
  },
  // landing_on_roles_module_fms: {
  //   event_name: EVENT_NAMES.page_view,
  //   content_type: CONTENT_TYPES.role_listing,
  // },
  booking_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.booking_listing,
  },
  add_new_booking_click: {
    interacted_from: PAGES.booking_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.create_new_booking,
  },
  import_booking_click: {
    interacted_from: PAGES.booking_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.import_booking,
  },
  booking_whatsapp_click: {
    interacted_from: PAGES.booking_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_whatsapp,
  },
  booking_edit_click: {
    interacted_from: PAGES.booking_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_edit,
  },
  booking_change_disposition_click: {
    interacted_from: PAGES.booking_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_change_disposition,
  },
  booking_restore_click: {
    interacted_from: PAGES.booking_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_restore,
  },
  booking_share_account_statement_click: {
    interacted_from: PAGES.booking_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_share_account_statement,
  },
  booking_share_account_statement_detail_click: {
    interacted_from: PAGES.booking_detail,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_share_account_statement,
  },
  booking_change_assignee_click: {
    interacted_from: PAGES.booking_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_change_assignee,
  },
  booking_history_click: {
    interacted_from: PAGES.booking_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_history,
  },
  booking_detail_page: {
    interacted_from: PAGES.booking_listing,
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.booking_detail,
  },
  booking_edit_installments_click: {
    interacted_from: PAGES.booking_detail,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_edit_installments,
  },
  booking_adjust_cost_click: {
    interacted_from: PAGES.booking_detail,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_adjust_cost,
  },
  booking_add_payment_click: {
    interacted_from: PAGES.booking_detail,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_add_payment,
  },
  booking_add_task_click: {
    interacted_from: PAGES.booking_detail,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_add_task,
  },
  booking_download_account_statement_click: {
    interacted_from: PAGES.booking_detail,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.booking_download_account_statement,
  },
  recovery_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.recovery_listing,
  },
  recovery_detail_page: {
    interacted_from: PAGES.recovery_listing,
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.recovery_detail,
  },
  transfer_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.transfer_listing,
  },
  add_transfer_click: {
    interacted_from: PAGES.transfer_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.add_transfer,
  },
  refund_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.refund_listing,
  },
  payment_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.payment_listing_v2,
  },
  add_payment_click: {
    interacted_from: PAGES.payment_listing_v2,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.add_new_payment,
  },
  payment_update_click: {
    interacted_from: PAGES.payment_listing_v2,
    event_name: EVENT_NAMES.payment_actions,
    content_type: CONTENT_TYPES.payment_update_v2,
  },
  tasks_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.tasks_listing,
  },
  tasks_add_task_click: {
    interacted_from: PAGES.tasks_listing,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.tasks_add_task,
  },
  client_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.client_listing_v2,
  },
  client_detail_page: {
    interacted_from: PAGES.client_listing_v2,
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.client_detail_v2,
  },
  client_edit_click: {
    interacted_from: PAGES.client_listing_v2,
    event_name: EVENT_NAMES.client_actions,
    content_type: CONTENT_TYPES.client_edit_v2,
  },
  approval_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.approval_listing,
  },
  user_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.user_listing,
  },
  role_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.role_listing_v2,
  },
  team_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.team_listing,
  },
  tenant_settings_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.tenant_settings,
  },
  project_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.project_listing_v2,
  },
  project_add_new_project_click: {
    interacted_from: PAGES.project_listing_v2,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.add_new_project,
  },
  project_detail_page: {
    interacted_from: PAGES.project_listing_v2,
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.project_detail,
  },
  project_filter_dropdown: {
    interacted_from: PAGES.project_listing_v2,
    event_name: EVENT_NAMES.filter,
    content_type: CONTENT_TYPES.project_filter_v2,
  },
  city_filter_dropdown: {
    interacted_from: PAGES.project_listing_v2,
    event_name: EVENT_NAMES.filter,
    content_type: CONTENT_TYPES.city_filter_v2,
  },
  project_edit_action: {
    interacted_from: PAGES.project_listing_v2,
    event_name: EVENT_NAMES.project_actions,
    content_type: CONTENT_TYPES.project_edit_v2,
  },
  project_status_action: {
    interacted_from: PAGES.project_listing_v2,
    event_name: EVENT_NAMES.project_actions,
    content_type: CONTENT_TYPES.project_status_v2,
  },
  project_app_action: {
    interacted_from: PAGES.project_listing_v2,
    event_name: EVENT_NAMES.project_actions,
    content_type: CONTENT_TYPES.project_app_v2,
  },
  project_history_action: {
    interacted_from: PAGES.project_listing_v2,
    event_name: EVENT_NAMES.project_actions,
    content_type: CONTENT_TYPES.project_history_v2,
  },
  unit_listing_page: {
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.unit_listing_v2,
  },
  project_filter_unit_click: {
    interacted_from: PAGES.unit_listing_v2,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.project_filter_unit,
  },
  unit_filter_unit_click: {
    interacted_from: PAGES.unit_listing_v2,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.unit_filter_unit,
  },
  property_category_filter_unit_click: {
    interacted_from: PAGES.unit_listing_v2,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.property_category_filter,
  },
  unit_type_unit_click: {
    interacted_from: PAGES.unit_listing_v2,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.unit_type_filter,
  },
  client_filter_unit_click: {
    interacted_from: PAGES.unit_listing_v2,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.client_filter,
  },
  unit_detail_page: {
    interacted_from: PAGES.unit_listing_v2,
    event_name: EVENT_NAMES.page_view,
    content_type: CONTENT_TYPES.unit_detail_v2,
  },
  unit_add_new_unit_click: {
    interacted_from: PAGES.unit_listing_v2,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.add_new_unit,
  },
  import_units_click: {
    interacted_from: PAGES.unit_listing_v2,
    event_name: EVENT_NAMES.click,
    content_type: CONTENT_TYPES.import_units,
  },
  unit_edit_action: {
    interacted_from: PAGES.unit_listing_v2,
    event_name: EVENT_NAMES.unit_actions,
    content_type: CONTENT_TYPES.unit_edit_v2,
  },
  unit_history_action: {
    interacted_from: PAGES.unit_listing_v2,
    event_name: EVENT_NAMES.unit_actions,
    content_type: CONTENT_TYPES.unit_history_v2,
  },
};
